import { Box } from "@mui/material";
import React from "react";
import ByzMuiTypography from "../mui/inputs/ByzMuiTypography";
//MPOGLU;453137;09042025
interface ByzTitleAndInputBoxProps {
  title: string;
  children: React.ReactNode;
  sx?: React.CSSProperties; //YATAY;452641;19042025
  marginLeft?: string; //YATAY;452641;19042025
  justifyContent?: string; //YATAY;452641;19042025
}

const ByzTitleAndInputBox: React.FC<ByzTitleAndInputBoxProps> = ({
  title,
  children,
  sx,
  marginLeft = "16px",
  justifyContent = "space-between"
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      {...(justifyContent !== "none" ? { justifyContent: justifyContent } : {})}
      height="100%"
      sx={{
        ...sx
      }}
    >
      
      <Box sx={title !== "" ?{minHeight : { xs:"55x", md: "40px"}} : undefined}>
        <ByzMuiTypography marginLeft={marginLeft}>{title}</ByzMuiTypography>
      </Box>
      {children}
    </Box>
  );
};

export default ByzTitleAndInputBox;
